<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">设备出货明细</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="queryDeviceList(pageNo,pageSize)">查询</el-button>
            <el-button style="float: right;margin-left:10px;" type="success" @click="exportDeviceList()">导出</el-button>
            
            <el-date-picker
                style="float: right;"
                v-model="date_value"
                type="daterange"
                align="right"
                :placeholder="today"
                :picker-options="pickerOptions">
            </el-date-picker>

            <el-input  v-model="device_value" auto-complete="on" placeholder="设备编号" style="float: right;width:200px;margin-right: 20px;"></el-input>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                style="width: 100%">
                <el-table-column
                    label="设备编号"
                    prop="deviceCode"
                    header-align="center"
                    min-width="110">
                </el-table-column>
                <el-table-column
                    prop="alias"
                    header-align="center"
                    min-width="95"
                    label="设备名">
                </el-table-column>
                <el-table-column
                    prop="deviceAddress"
                    header-align="center"
                    min-width="70"
                    label="设备地址">
                </el-table-column>
                <el-table-column
                    prop="outNum"
                    header-align="center"
                    min-width="70"
                    label="增粉次数">
                </el-table-column>
                
                <!-- <el-table-column
                    prop="userSetting"
                    header-align="center"
                    min-width="100"
                    label="操作">
                    <template scope="scope">
                      <el-button type="text" size="small" 
                        @click="lookAcc(scope.row.appId,scope.row.name,scope.row.count)">查看详细</el-button>
                    </template>
                  </el-table-column> -->
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
    </div>
</template>

<script>
import $axios from '../../https/config'

export default {
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' - ' + new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      date_value: '',
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0,
      device_value:'',
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList(this.pageNo, this.pageSize)
  },
  methods: {
    exportDeviceList(){


      this.$prompt('因为导出所需要时间比较久，请输入邮箱，导出完成后会直接发送到邮箱', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          // this.$message({
          //   type: 'success',
          //   message: '你的邮箱是: ' + value
          // });


          var url
          var params
          var sDate = new Date(this.date_value[0])
          var eDate = new Date(this.date_value[1])
      
          var tStartDate = sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate()
          var tEndDate = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()

          if (this.date_value === '' || sDate.getFullYear() === 1970) {
            tStartDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
            tEndDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()

            url = '/statictis/exportDeviceStatictisByDate'
            params = {
        
              startDate: tStartDate,
              endDate: tEndDate,
              deviceCode: this.device_value,
              email: value,
            }
          } else {
            url = '/statictis/exportDeviceStatictisByDate'
            params = {
              email: value,
              startDate: tStartDate,
              endDate: tEndDate,
              deviceCode: this.device_value,
            }
          }

          var _this = this
          $axios.get(url, params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
             
              
              
            } else {
            }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });


     

      }, function () {})

    },
    queryDeviceList (tPageNo, tPageSize) {
      var url
      var params
      var sDate = new Date(this.date_value[0])
      var eDate = new Date(this.date_value[1])
      this.table_loading = true
      var tStartDate = sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate()
      var tEndDate = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()
      // console.log(this.today);
      if (this.date_value === '' || sDate.getFullYear() === 1970) {
        tStartDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
        tEndDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()

        url = '/statictis/getDeviceStatictisByDate'
        params = {
          pageNo: tPageNo,
          pageSize: tPageSize,
          startDate: tStartDate,
          endDate: tEndDate,
          deviceCode: this.device_value,
        }
      } else {
        url = '/statictis/getDeviceStatictisByDate'
        params = {
          pageNo: tPageNo,
          pageSize: tPageSize,
          startDate: tStartDate,
          endDate: tEndDate,
          deviceCode: this.device_value,
        }
      }
      var _this = this
      $axios.get(url, params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              // console.log(itemData);
              var item = {
                deviceCode: itemData.deviceCode,
                 alias: itemData.alias==null?"":itemData.alias,
                deviceAddress: itemData.address==null?"":itemData.address,
                outNum:itemData.outNum==null?0:itemData.outNum
                
              }

              // console.log(item);
              resData.push(item)
            }

            // console.log("2");
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
            // console.log(resData);
          }
        } else {
        }
        _this.table_loading = false
      }, function () {})
    },
    lookAcc (appId,appName,count) {
          this.$router.push({path: '../deviceInfo/wxUserInfo', query: {'appId': appId, 'appName': appName, 'count': count}})
      },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList(this.pageNo, this.pageSize)
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList(this.pageNo, this.pageSize)
    }
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
</style>


// WEBPACK FOOTER //
// src/page/dataStatistics/deviceOutGoods.vue